<template>
  <form class="form-horizontal">
    <div v-loading="!show"
          element-loading-text="Carregando..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" >
      <card v-if="show"
          >
        <div slot="header" class="card-header" >
          <h4 class="card-title" >{{plano.shelves[0].vm_location}}</h4>
        </div>
        <div class="table-responsive table-full-width">
          <el-table :data="tableOne" border :show-header="false" v-loading="loading">
            <el-table-column label="Molas">
              <div slot-scope="props">
                <h5
                  v-if="props.row.position || props.row.position == 0"
                >{{ `Prateleira ${String.fromCharCode(props.row.position + 65)}` }}</h5>
                <el-table :data="tableTwo(props.$index)" width="100%" border >
                  <el-table-column label="#" width="70">
                    <template slot-scope="props" >{{ props.row.position + 1 }}</template>
                  </el-table-column>
                  <el-table-column label="Produto" min-width="250">
                    <template slot-scope="props">
                      <fg-input>
                        <el-select
                          class="select-default"
                          size="large"
                          filterable
                          @blur="clearVar(props.row)"
                          placeholder="Digite para filtar"
                          v-model="props.row.product"
                        >
                          <el-option
                            v-for="option in products"
                            class="select-danger"
                            :value="option.id"
                            :label="`${option.name}`"
                            :key="option.id"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Variação" min-width="250">
                    <template slot-scope="props">
                      <fg-input>
                        <el-select
                          class="select-default"
                          size="large"
                          filterable
                          placeholder="Digite para filtrar"
                          v-model="props.row.product_variant"
                        >
                          <el-option
                            v-for="option in productVariants(props.row.product)"
                            class="select-danger"
                            :value="option.id"
                            :label="`${option.name}`"
                            :key="option.id"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Capacidade" width="100">
                    <template slot-scope="props">
                      <fg-input v-model="props.row.capacity"></fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Quantidade" width="100">
                    <template slot-scope="props">
                      <fg-input @blur="QuantvsCap(props.row)" v-model="props.row.amount"></fg-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Validade" width="170">
                    <template slot-scope="props">
                      <fg-input>
                        <el-date-picker
                          v-model="props.row.expiration_date"
                          type="date"
                          format="dd/MM/yyyy"
                          placeholder="Selecione"
                        ></el-date-picker>
                      </fg-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-table-column>
          </el-table>
        </div>
        
        <div slot="footer" >
          <el-button type="primary" :loading="btnLoading" style="margin-left: 0px"
            @click.prevent="importSupply()">Baixar abastecimento</el-button>

          <el-button type="warning" :loading="btnLoading"  style="margin-left: 20px"
          @click.prevent="viewSupply()">Visualizar abastecimento</el-button>

          <el-button type="success" :loading="btnLoading" 
            @click.prevent="saveCoils">Salvar</el-button>
        </div>
      </card>
    </div>
   <el-dialog center :visible.sync="supplyDialog" title="Abastecimento">
      <card class="row">
        <div class="table-responsive table-full-width" >
          <el-table class="table-striped" :data="tableData"  >
            <el-table-column label="Mola" property="position" />
            <el-table-column label="Produto" property="product"  />
            <el-table-column label="Variação" property="product_variant"  />
            <el-table-column label="Abastecimento" property="supply"  />
          </el-table>
        </div>
      </card>
   </el-dialog>
  </form>
</template>
<script>
import {
  Select,
  Button,
  Option,
  DatePicker,
  TimeSelect,
  Dialog,
  Slider,
  Loading,
  Table,
  TableColumn
} from "element-ui";

import { Switch as LSwitch } from "src/components/index";
import swal from "sweetalert2";
import XLSX from 'xlsx'

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Slider.name]: Slider,
    [Table.name]: Table,
    [Button.name]: Button,
    [TableColumn.name]: TableColumn,
    LSwitch
  },
  data() {
    return {
      crud: "Editar",
      supplyDialog: false,
      supply: [],
      loading: true,
      plano: [],
      btnLoading: false,
      fullscreenLoading: true,
      message: "Sucesso</br>Item Salvo!",
      alertColor : '',
      show: false,
      model: {
        user: "",
        location: "",
        vpn_key: "",
        mac: "",
        ip: "",
        last_communication: "",
        coil_per_shelf: "",
        sound: false,
        volume: 30,
        maintence_pwd: "",
        repositor_pwd: "",
        payment: false,
        shelf: '',
        video: false,
        serial_term: "",
        itens_per_sale: "",
        id_externo: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  created () {},
  mounted() {
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) { 
      ciaID = ciaID
    } else {
      ciaID = ''
    }
    if (this.$route.params.id) {
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
      this.$store.dispatch('machines/getPlan',{sort: '?vm='+ this.$route.params.id}).then(resp =>{
        console.log('plano', resp.shelves)
        this.plano = resp
        this.getData(ciaID)
        
    })
  },
  computed: {
    tableOne(){
      this.plano.shelves = this.plano.shelves.sort((a,b) => (Number(a.position) > Number(b.position)) ? 1 : ((Number(b.position) > Number(a.position)) ? -1 : 0))
      this.loading = false
      return this.plano.shelves
    },
    users() {
      return this.$store.state.users.users;
    },
    products() {
      const p = this.$store.state.products.products;
      const withVariants = p.map(v => {
        const variants = this.variants.filter(e => e.product == v.id);
        return { ...v, variants };
      });
      return withVariants;
    },
    variants() {
      return this.$store.state.products.variants.variants;
    },
    shelves() {
      return this.$store.state.shelves.shelves;
    },
    coils() {
      return this.$store.state.stock.coils;
    },
    productVariants() {
      return product => {
        const p = this.products.find(e => e.id == product) || {};
        const v = p.variants;
        return v;
      };
    },
    tableData () {
      return this.supply
    }
  },
  methods: {
    getData (ciaID) {
      this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID + '&archived=False'}).then(() => {
        this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID + '&archived=False'}).then(() =>{
          this.show = true
        })
      })
    },
    tableTwo(index) {
      var secoundTable = this.plano.shelves[index].coils.filter(el=>{
        return (el.active === true)
      })
      return secoundTable
    },
    saveCoils() {
      this.btnLoading = true
        var comp =[]  
      const middle = this.tableOne.map(v =>{
        let shelf
        comp.push(...v.coils)
        return comp
      })
      console.log('tab', this.tableOne)
      var dateConverted = middle[0].map(v => {
        let expiration_date
        if (v.expiration_date) {
          console.log('v', v.expiration_date)
          const d = new Date(v.expiration_date).toISOString();
          expiration_date = d.split("T")[0];
        } else {
          expiration_date = null
        }
        return {...v, expiration_date}
      })
      console.log('router', this.$route.params.id)
      let payload = { data: dateConverted, item: this.$route.params.id};
      console.log('payload', payload)
      this.$store.dispatch("machines/update_coils", payload).then(result => {
        console.log('result', result)
          this.btnLoading = false
        if (result[0].id) {
          var color
          this.message = "Sucesso</br>Item Salvo!" 
          color = 'success'
          for (let index = 0; index < payload.data.length; index++) {
            if (payload.data[index].product === null && payload.data[index].active){
                this.message = 'Sucesso</br>Item Salvo! Mas há molas vazias.'  
                color = 'warning'      
              }
            }
          this.$notify({
            message: this.message,
            icon: "nc-icon nc-app",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: color
          });

          this.$router.push('/app/machines/machines/')
        } else {
          this.btnLoading = false
          this.$notify({
            message: "Erro</br>VM não atualizada!",
            icon: "nc-icon nc-app",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger"
          })
        }
      })
    },
    importSupply() {
      this.btnLoading = true
      this.$store.dispatch('general/excelSupply',{search: '?vm='+this.$route.params.id}).then(resp => {
        console.log('res', resp)
        this.message = 'Baixando o abastecimento'
        this.notifySuccess()
        this.btnLoading = false
      })
    },
    viewSupply() {
      this.$store.dispatch('general/getSupply',{search: '?vm='+this.$route.params.id}).then(resp => {
        console.log('res', resp)
        this.supply = resp.data
        this.btnLoading = false
        this.supplyDialog = true
      })
    },
    notifySuccess() {
      this.$notify({
        message: this.message,
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    color(value) {
      if (value <= 75) {
        return "slider-success";
      } else {
        return "slider-danger";
      }
    },
    QuantvsCap (item) {
      if (Number(item.amount) > Number(item.capacity)) {
        alert('Quantidade não pode ser maior que Capacidade')
        item.amount = item.capacity
      }
    },
    clearVar (data) {
      data.product_variant = ''
      setTimeout(() => {
        var a = this.products.filter(v =>{
          if (v.id === data.product) {
            if (v.variants.length > 0) {
              data.product_variant = v.variants[0].id
            }
          }
        })
      }, 200);
    },
  }
};
</script>
<style scoped>
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.card-header {
  display: flex;
}
.card-header button {
  margin-left: auto;
}
.card-footer {
  display: flex;
  text-align: right;
}
.card-footer > div {
  display: flex;
  text-align: right;
}
.card-footer button {
  margin-left: auto;
}
.table-responsive .form-group {
  margin: 0;
}
</style>
